import { Theme } from "@Utils/theme";
import { createText } from "@shopify/restyle";

const Text = createText<Theme>();

export default Text;
